export default __webpack_public_path__ + "static/media/cover.3ec2ba3f.png";